var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app app-ti_green"},[_c('router-view'),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }